import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import AuthServiceApp from "./AuthServiceApp.vue";
import ShoplusAuthServiceApp from "./ShoplusAuthServiceApp.vue";
import ShoplusServiceApp from "./ShoplusServiceApp.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@mdi/font/css/materialdesignicons.css";

Vue.config.productionTip = false;

/**
 * 기본 root app
 */
let Application = App;

/**
 * 앞으로 추가할 앱들
 */
let ApplicationList = {
  // 정품인증앱
  authservice: AuthServiceApp,
  shoplus_authservice: ShoplusAuthServiceApp,
  shoplus_service: ShoplusServiceApp,
};

new Vue({
  data: {
    currentRoute: null,
    path: window.location.pathname,
  },
  computed: {
    getApplication: function() {
      let appName = this.path.split("/", 3);
      if (ApplicationList[appName[1]]) {
        if (appName[1] === "authservice" && ["login", "join", "find-password", "reset-password"].includes(appName[2])) {
          return App;
        } else {
          return ApplicationList[appName[1]];
        }
      } else {
        return App;
      }
    },
  },
  created: function() {
    Application = this.getApplication;
  },
  router,
  store,
  vuetify,
  render: (h) => h(Application),
}).$mount("#app");
